import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=0b23989e&"
import script from "./Statistics.vue?vue&type=script&lang=ts&"
export * from "./Statistics.vue?vue&type=script&lang=ts&"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=0b23989e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports